const namespace = 'APPS';

export const REQUEST_APPS = `${namespace}/REQUEST_APPS`;
export const RECEIVE_APPS_SUCCESS = `${namespace}/RECEIVE_APPS_SUCCESS`;
export const RECEIVE_APPS_FAILURE = `${namespace}/RECEIVE_APPS_FAILURE`;
